import CryptoJS from 'crypto-js';

// Secure API Key for dev environment (matches Flutter F.secureApiKey)
const SECURE_API_KEY = '915967926258aacc4c640e32b5935741';

/**
 * Generates a secure token for API authorization
 * Matches Flutter's AuthService.generateSecureToken()
 *
 * Format: timestamp.ivHex.encryptedHex
 */
export function generateSecureToken(): string {
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const payload = `${timestamp}.centrajob`;

  // Convert hex key to WordArray
  const key = CryptoJS.enc.Hex.parse(SECURE_API_KEY);

  // Generate random 16 bytes IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt with AES-CBC
  const encrypted = CryptoJS.AES.encrypt(payload, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Convert IV and ciphertext to hex
  const ivHex = iv.toString(CryptoJS.enc.Hex);
  const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

  return `${timestamp}.${ivHex}.${encryptedHex}`;
}
